<template>
  <div v-if="showModal" class="card-modal">
    <div class="icon">
      <img
        :src="'https://mdl.mfu.ac.th' + profile_image"
        alt=""
        class="imageAvatar"
      />
    </div>
    <div class="body">
      <div class="message">
        <div class="body_message">
          <p :class="checkLangClass()">{{ checkLanguage(message) }}</p>
        </div>
      </div>
      <div v-if="getWidth > 414" class="body_action" @click="next(index)">
        <div class="action">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="75"
            height="75"
            fill="white"
            class="bi bi-arrow-right-circle-fill"
            viewBox="0 0 16 16"
          >
            <path
              d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z"
            />
          </svg>
        </div>
      </div>
      <div v-if="getWidth <= 414" class="mobile-btn-next">
        <div class="button button-next" @click="next(index)">
          <div col="12">
            <div style="font-size: 18px">NEXT</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import "../../../assets/scss/_chineseStyle.scss";
import '../../../assets/scss/chinessStyle2.scss';
export default {
  props: {
    index: Number,
    message: Array,
    showModal: Boolean,
    profile_image: String,
    lang: String,
  },
  data() {
    return {
      getWidth: window.innerWidth,
    };
  },
  methods: {
    next: function (index) {
      this.$emit('returnIndex', index);
    },
    checkLanguage: function (val) {
      if (val) {
        try {
          for (let i = 0; i <= val.length; i++) {
            if (val[i].key != null) {
              if (val[i].key.toUpperCase() == this.lang) {
                return val[i].value;
              }
            }
          }
        } catch (err) {
          console.log('change language is error 1!!');
        }
      } else {
        console.log('change language is error 2!!');
      }
    },
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
  },

  created() {},
};
</script>

<style scoped lang="scss">
.imageAvatar {
  width: 210px;
}
.card-modal {
  width: 100%;
  height: 100%;
  position: relative;
}
.body {
  border-radius: 20px;
  background-color: #1e5bd7;
  width: 100%;
  display: flex;
}
.message {
  width: 100%;
  background-color: white;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  border-radius: 10px 0px 0px 10px;
}
.body_message {
  width: 80%;
  height: 100%;
  font-size: 36px;
  display: flex;
  align-items: center;
  /* background-color: white; */
}

.icon {
  position: absolute;
  height: 100%;
  left: 0;
  object-fit: contain;
  display: flex;
  justify-content: flex-start;
  padding: 0;
  margin: 0;
  z-index: 1;
  cursor: auto;
}
.body_action {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: 200px;
}
.action {
  padding-left: 15px;
  padding-right: 15px;
}
.action:hover svg {
  fill: #e2e8f0;
}

.row {
  margin: 0;
  padding: 0;
  height: 100%;
}

@media screen and (min-width: 300px) and (max-width: 600px) {
  .imageAvatar {
    width: 160px;
  }
  .icon {
    width: 100%;
    height: 43%;
    z-index: 0;
    position: relative;
    // background-color: red;
    display: flex;
    justify-content: center;
  }

  .message {
    height: auto;
    position: relative;
    justify-content: center;
  }

  .body {
    flex-direction: column;
    background-color: white;
  }
  .card-modal {
    width: 100%;
    position: relative;
    height: auto;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    border-radius: 10px;
    background-color: white;
  }
  .body_message {
    font-size: 24px;
    width: 90%;
    justify-content: center;
    // background-color: green;
  }
  .button {
    width: 145px;
    height: 43px;
    margin-bottom: 0;
    background-color: #89abe6;
    color: white;
    font-size: 12px;
    border-radius: 8px !important;
    cursor: pointer;
  }
  .mobile-btn-next {
    position: relative;
    bottom: 0;
    height: 20%;
    width: 100%;
    // background-color: wheat;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 20px;
  }
}

@media only screen and (min-width: 768px) and (max-width: 1023px) {
  .body_message {
    justify-content: center;
    width: 68%;
  }
}

@media only screen and (min-width: 1024px) and (max-width: 1367px) {
  .body_message {
    width: 78%;
    justify-content: center;
    font-size: 28px;
  }
}
@media only screen and (min-width: 1036px) and (max-width: 1050px) {
}
</style>
